import axios from 'axios';
import { appConfig } from '../../Config/app';

const authAPI = axios.create({
  baseURL: appConfig.API_BASE_URL,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
});

const dataToFormData = data => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      const element = data[key];
      formData.append(key, element);
    }
  }

  return formData;
};

function apiGetAllOrgRobots(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.get(`/api/v1/gear/get-all-org-robots/${action.organisationId}/`, {headers});
}


function apiBulkOnboardOrgRobot(action) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Token ${action.token}`,
  };
  // JSON (not FormData) — the payload has a nested `robots` list + `shared_config`.
  return authAPI.post(`/api/v1/gear/org-robots/bulk/`, action.payload, { headers });
}

function apiUpdateOrgRobot(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.robotData);
  return authAPI.patch(`/api/v1/gear/org-robot/${action.robotData.id}/`, formData,
    {
      headers,
    },
  );
}

function apiCreateShootRobot(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.robotData);
  return authAPI.post(`/api/v1/gear/shoot-robot/`, formData,
    {
      headers,
    },
  );
}

function apiGetAllShootRobots(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.get(`/api/v1/gear/get-all-shoot-robots/${action.projectId}/`, {headers});
}

function apiUpdateShootRobot(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.updateData);
  return authAPI.patch(`/api/v1/gear/shoot-robot/${action.robotId}/`, formData,
    {
      headers,
    },
  );
}

function apiDeleteShootRobot(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.delete(`/api/v1/gear/shoot-robot/${action.robotId}/`, {headers});
}

function apiGetRobotAvailability(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.get(`/api/v1/gear/robot/${action.airId}/availability/`, {headers});
}

function apiGetAllOrgInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.get(`/api/v1/gear/get-all-org-instances/${action.organisationId}/`, {headers});
}

function apiOnboardOrgInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.instanceData);
  return authAPI.post(`/api/v1/gear/org-instance/`, formData,
    {
      headers,
    },
  );
}

function apiUpdateOrgInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.instanceData);
  return authAPI.patch(`/api/v1/gear/org-instance/${action.instanceData.id}/`, formData,
    {
      headers,
    },
  );
}

function apiCreateShootInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.instanceData);
  return authAPI.post(`/api/v1/gear/shoot-instance/`, formData,
    {
      headers,
    },
  );
}

function apiGetAllShootInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.get(`/api/v1/gear/get-all-shoot-instances/${action.projectId}/`, {headers});
}

function apiUpdateShootInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.updateData);
  return authAPI.patch(`/api/v1/gear/shoot-instance/${action.instanceId}/`, formData,
    {
      headers,
    },
  );
}

function apiDeleteShootInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.delete(`/api/v1/gear/shoot-instance/${action.instanceId}/`,{headers,});
}

function apiGetAllShootInstancesLiveStatus(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };

  return authAPI.post(`/api/v1/gear/aws/ec2/get-all-shoot-instances-live-status/`, action.instancesArr, {headers,});
}

function apiGetShootInstanceLiveStatus(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };

  return authAPI.get(`/api/v1/gear/aws/ec2/get-shoot-instance-live-status/`,
    {params: {
      region: action.instanceRegion,
      id: action.instanceAirId,
    }},
    {headers: headers,});
}

function apiStartShootInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.instanceData);
  return authAPI.post(`/api/v1/gear/aws/ec2/start-shoot-instance/`, formData, {headers,});
}

function apiStopShootInstance(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.instanceData);
  return authAPI.post(`/api/v1/gear/aws/ec2/stop-shoot-instance/`, formData, {headers,});
}

function apiUpdateRobotZCamSingleSetting(action) {
  const headers = {
    Authorization: `Token ${action.token}`,
  };
  return authAPI.post(`/api/v1/gear/robot-zcam-settings/single-setting/`, action.payload, {headers: headers});
}

function apiGetInventoryOnPremServerInfo(action) {
  const headers = {
    Authorization: `Token ${action.token}`,
  };
  return authAPI.get(`/api/v1/gear/air-on-prem-servers/${action.airId}/`, {headers: headers});
}

function apiOnboardOrgOnPremServer(action) {
  const headers = {
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.onboardData);
  return authAPI.post(`/api/v1/gear/org-on-prem-servers/`, formData, {headers: headers});
}

function apiUpdateOrgOnPremServer(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  const formData = dataToFormData(action.updateData);
  return authAPI.patch(`/api/v1/gear/org-on-prem-servers/${action.updateData.id}/`, formData, {headers: headers});
}

function apiGetAllOrgOnPremServers(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.get(`/api/v1/gear/org-on-prem-servers/?organization_id=${action.organizationId}`, {headers: headers});
}

export const gearServices = {
  apiGetAllOrgRobots,
  apiBulkOnboardOrgRobot,
  apiUpdateOrgRobot,
  apiCreateShootRobot,
  apiGetAllShootRobots,
  apiUpdateShootRobot,
  apiDeleteShootRobot,
  apiGetRobotAvailability,
  apiGetAllOrgInstance,
  apiOnboardOrgInstance,
  apiUpdateOrgInstance,
  apiCreateShootInstance,
  apiGetAllShootInstance,
  apiUpdateShootInstance,
  apiDeleteShootInstance,
  apiGetAllShootInstancesLiveStatus,
  apiGetShootInstanceLiveStatus,
  apiStartShootInstance,
  apiStopShootInstance,
  apiUpdateRobotZCamSingleSetting,
  apiGetInventoryOnPremServerInfo,
  apiOnboardOrgOnPremServer,
  apiUpdateOrgOnPremServer,
  apiGetAllOrgOnPremServers,
};